import {
    CREATE_PRIZE,
    CREATE_PRIZE_SUCCESS,

    GET_PRIZES,
    GET_PRIZES_SUCCESS,

    UPDATE_PRIZE,
    UPDATE_PRIZE_SUCCESS,

    DELETE_PRIZE,
    DELETE_PRIZE_SUCCESS
} from './constants';

/**
 *
 * @param calendarID
 * @returns {{calendarID: *, type: string}}
 */
const createPrize = calendarID => ( {
    type: CREATE_PRIZE,
    calendarID
} );
/**
 *
 * @param prize
 * @returns {{type: string, prize: *}}
 */
const createPrizeSuccess = prize => ( {
    type: CREATE_PRIZE_SUCCESS,
    prize
} );
/**
 *
 * @param prizes
 * @returns {{prizes: *, type: string}}
 */
const getPrizes = prizes => ( {
    type: GET_PRIZES,
    prizes
} );
/**
 *
 * @param prizes
 * @returns {{prizes: *, type: string}}
 */
const getPrizesSuccess = prizes => ( {
    type: GET_PRIZES_SUCCESS,
    prizes
} );
/**
 *
 * @param prizeID
 * @returns {{type: string, prizeID: *}}
 */
const deletePrize = prizeID => ( {
    type: DELETE_PRIZE,
    prizeID
} );
/**
 *
 * @param prizes
 * @returns {{prizes: *, type: string}}
 */
const deletePrizeSuccess = prizes => ( {
    type: DELETE_PRIZE_SUCCESS,
    prizes
} );
/**
 *
 * @param prizeID
 * @param prizeObj
 * @returns {{prizeObj: *, type: string, prizeID: *}}
 */
const updatePrize = ( prizeID, prizeObj ) => ( {
    type: UPDATE_PRIZE,
    prizeID,
    prizeObj
} );
/**
 *
 * @param prizes
 * @returns {{prizes: *, type: string}}
 */
const updatePrizeSuccess = prizes => ( {
    type: UPDATE_PRIZE_SUCCESS,
    prizes
} );

export {
    createPrize,
    createPrizeSuccess,
    getPrizes,
    getPrizesSuccess,
    updatePrize,
    updatePrizeSuccess,
    deletePrize,
    deletePrizeSuccess
};